import { css } from '@emotion/react';
import {
  type ComponentProps, useCallback,
} from 'react';
import { SliderWithValueLabelsComponent } from '~/_shared/components/slider/sliderWithValueLabels/sliderWithValueLabels.component';
import { useTranslation } from '~/_shared/utils/hooks';

const METRICS_PADDING_LARGE = 20;

const slicerContainer = css({
  ':not(:last-of-type)': {
    marginBottom: METRICS_PADDING_LARGE,
  },
});

const helperText = css({
  fontSize: '.75em',
});

const helperTextSection = css({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
});

const slider = css({
  paddingBottom: 0,
});

type WeightMetric = {
  id: string;
  name: string;
  weight: number;
};

type DataWeightsItemProps = Omit<
  ComponentProps<typeof SliderWithValueLabelsComponent>,
  'min'|'max'|'onChange'|'noLabel'|'value'|'currentValueOnTheRight'|'className'|'valueSuffix'
> & {
  className?: string;
  metric: WeightMetric;
  minWeight: number;
  maxWeight: number;
  onChange: (newMetric: WeightMetric) => void;
};

export const DataWeightsItemComponent = ({ metric, onChange, className, minWeight, maxWeight, ...restProps }: DataWeightsItemProps) => {
  const [t] = useTranslation();
  const onMetricChange = useCallback((newWeight: number) => {
    onChange({
      id: metric.id,
      name: metric.name,
      weight: newWeight,
    });
  }, [metric.id, metric.name, onChange]);

  return (
    <div className={className} css={slicerContainer}>
      <span>{metric.name}</span>
      <SliderWithValueLabelsComponent
        {...restProps}
        css={slider}
        currentValueOnTheRight
        noLabel
        onChange={([weight]) => onMetricChange(weight)}
        value={[metric.weight]}
        min={minWeight}
        max={maxWeight}
        valueSuffix="%"
      />
      <span css={helperTextSection}>
        <span css={helperText}>{t('Less important')}</span>
        <span css={helperText}>{t('More important')}</span>
      </span>
    </div>
  );
};
